var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { observable, action } from 'mobx';
import keyBy from 'lodash/keyBy';

import { maybeCall } from 'sdc-utilities';
import * as store from './StoreHelper';

export var BaseStore = (_class = function BaseStore(_ref) {
  var _this = this;

  var _ref$listName = _ref.listName,
      listName = _ref$listName === undefined ? 'content' : _ref$listName,
      _ref$entryName = _ref.entryName,
      entryName = _ref$entryName === undefined ? 'content' : _ref$entryName,
      options = _objectWithoutProperties(_ref, ['listName', 'entryName']);

  _classCallCheck(this, BaseStore);

  _initDefineProp(this, 'dataList', _descriptor, this);

  _initDefineProp(this, 'selected', _descriptor2, this);

  _initDefineProp(this, 'fields', _descriptor3, this);

  this.listName = null;
  this.entryName = null;
  this.options = {};
  this.afterUpdate = null;

  this.checkForPayload = function (payload, key) {
    if (!payload[key]) {
      throw new Error('payload does not contain \'' + key + '\'');
    }
  };

  this.setEntries = function (deferred) {
    return action(function (payload) {
      _this.checkForPayload(payload, _this.listName);

      if (!_this.options.noClearAfterLoad) maybeCall(_this.clearSelected)();
      _this.dataList = payload[_this.listName];
      if (payload.fields) {
        _this.fields = keyBy(payload.fields, 'key');
      }
      if (deferred) maybeCall(deferred.resolve)(_this.dataList);
    });
  };

  _initDefineProp(this, 'clearEntries', _descriptor4, this);

  this.listName = listName;
  this.entryName = entryName;
  this.options = options;
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'dataList', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'selected', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'fields', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'clearEntries', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      maybeCall(_this2.clearSelected)();
      _this2.dataList = [];
    };
  }
})), _class);